export default [
  {
    title: "Home",
    route: "admin",
    icon: "HomeIcon",
  },
  {
    title: "Manage Careers",
    route: 'allcareers',
    icon: "UserPlusIcon",
  },
  {
    title: "Manage Contacts",
    route: 'allcontacts',
    icon: "InboxIcon",
  },
  {
    title: "Location",
    route: 'alllocations',
    icon: "MapIcon",
  },
];
